import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {fetchMoreObjects, fetchObjects} from "../store/actions";
// import EventItem from "./Components/EventItem";
import EventItem from "../Components/EventItemT";
import LoadMoreButton from "../Components/LoadingMoreButton";
import LoadingIndicator from "../Components/LoadingIndicator";



class EventsScreen extends PureComponent {
  componentDidMount() {
    this.refresh();
  }

  refresh = () => {
    let {dispatch} = this.props;
    dispatch(fetchObjects('events'));
  };

  onLoadMore = async () => {
    let {dispatch, events: {next}} = this.props;
    dispatch(fetchMoreObjects('events', next));
  };

  render() {
    let {events} = this.props;
    let {list, loadingMore, next, refreshing} = events;

    return (
        <div className={'container'}>
          <LoadingIndicator loading={refreshing} />

          {list.map((event) => {
            return <EventItem event={event} key={'event' + event.id}/>
          })}

          <LoadMoreButton
              onClick={this.onLoadMore} hasNext={next} loading={loadingMore}
          />
          <br/>
          <br/>
        </div>
    )
  }
}

export default connect(({events}) => ({events}))(EventsScreen);
